//
//
//
//
//
//
//
//

export default {
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize () {
      return this.size / 2
    },

    spinnerStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    },

    spinnerBlockStyle () {
      return {
        animationDuration: `${this.animationDuration}ms`,
        width: `${this.circleSize}px`,
        height: `${this.circleSize}px`
      }
    },

    circleStyle () {
      return {
        borderColor: this.color
      }
    },

    circleStyles () {
      const circlesPositions = [
        {top: 0, left: 0},
        {left: `${this.circleSize * -0.36}px`, top: `${this.circleSize * 0.2}px`},
        {left: `${this.circleSize * -0.36}px`, top: `${this.circleSize * -0.2}px`},
        {left: 0, top: `${this.circleSize * -0.36}px`},
        {left: `${this.circleSize * 0.36}px`, top: `${this.circleSize * -0.2}px`},
        {left: `${this.circleSize * 0.36}px`, top: `${this.circleSize * 0.2}px`},
        {left: 0, top: `${this.circleSize * 0.36}px`}
      ]

      return circlesPositions.map((cp) => Object.assign(cp, this.circleStyle))
    }
  }
}
